<template>
  <v-container class="pa-0 wizard-kalkulacia">
    <v-form v-model="formValid" ref="form" autocomplete="off">
      <h1 v-if="!isMobile" @click="log" class="mt-45px mb-28px">Kalkulácia</h1>
      <debug-control
        @click="log"
        v-if="debug"
        :value="[
          'validationObjectResult',
          'formValid',
          'somethingGetDirty',
          'somethingIsLoading',
          'currentControl',
          'pripad',
        ]"
        :parent="this"
      />
      <v-card class="card">
        <v-row :no-gutters="isMobile" v-show="isControlVisible('cbAkontacia','liw_filip__wiz_kalkulacia__cb_akontacia',true)">
          <v-col xl="9" lg="9" md="9">
            <akontacia-button-group
              dynamic
              ref="cbAkontacia"
              :parentReloaded="reloaded"
              @valueChanged="akontaciaTenorChanged()"
              :cisloPredmetu="pripad.cisloPredmetu"
              dataId="liw_filip__wiz_kalkulacia__cb_akontacia"
              multiple
              :max="5"
              chip
              :mandatory="false"
              :disabled="isCalculating"
              showRequired
            />
          </v-col>
        </v-row>
        <v-row :no-gutters="isMobile" :class="{ 'mt-16px' : isMobile }" v-show="isControlVisible('txtAkontacia','liw_filip__wiz_kalkulacia__txt_akontacia_s_dph',true)">
          <v-col xl="4" lg="4" md="4">
            <numeric-text-box
              dynamic
              ref="txtAkontacia"
              :parentReloaded="reloaded"
              @valueChanged="akontaciaTxtChanged()"
              :cisloPredmetu="pripad.cisloPredmetu"
              dataId="liw_filip__wiz_kalkulacia__txt_akontacia_s_dph"
              @focus="akontaciaTxtFocus()"
              suffix="€"
              :disabled="isCalculating"
            />
          </v-col>
        </v-row>
        <v-row :class="{'mb-12px': isMobile }" :no-gutters="isMobile" v-show="isControlVisible('cbAkontacia','liw_filip__wiz_kalkulacia__cb_akontacia',true)">
          <v-col xl="12" lg="12" md="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-row :no-gutters="isMobile">
          <v-col xl="9" lg="9" md="9">
            <button-group v-if="pripad.jeFlSu"
              dynamic
              ref="tenor"
              :parentReloaded="reloaded"
              @valueChanged="akontaciaTenorChanged()"
              :cisloPredmetu="pripad.cisloPredmetu"
              dataId="liw_filip__wiz_kalkulacia__cb_tenor"
              chip
              :max="3"
              multiple
              :mandatory="false"
              info="Maximálne 3 možnosti"
              :disabled="isCalculating"
              showRequired
              labelTooltip
            />
            <button-group v-else
              dynamic
              ref="tenor"
              :parentReloaded="reloaded"
              @valueChanged="akontaciaTenorChanged()"
              :cisloPredmetu="pripad.cisloPredmetu"
              dataId="liw_filip__wiz_kalkulacia__cb_tenor"
              chip
              :mandatory="false"
              info="Vyberte 1 možnosti"
              :disabled="isCalculating"
              showRequired
              labelTooltip
            />
          </v-col>
        </v-row>

        <template v-if="pripad.jeOlfs">
          <v-row class="pt-12px mb-12px" no-gutters>
            <v-col xl="12" lg="12" md="12">
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row :no-gutters="isMobile" :class="{ 'mt-16px' : isMobile }">
            <v-col xl="4" lg="4" md="4">
              <dynamic-combo
                ref="rocny_najazd"
                @valueChanged="onRocnyNajazdChanged"
                :parentReloaded="reloaded"
                key="liw_filip__wiz_kalkulacia__cb_rocny_najazd"
                dataId="liw_filip__wiz_kalkulacia__cb_rocny_najazd"
                :cisloPredmetu="pripad.cisloPredmetu"
                :disabled="isCalculating"
              ></dynamic-combo>
            </v-col>
          </v-row>
          <v-row class="pt-12px mb-12px" no-gutters>
            <v-col xl="12" lg="12" md="12">
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </template>

        <v-row v-if="isMobile" class="pt-12px mb-12px" no-gutters>
          <v-col xl="12" lg="12" md="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>

        <v-row class="mobile-flex-direction-kalkulacia" :no-gutters="isMobile">
          <v-col xl="4" lg="4" md="4" sm="12" v-show="isControlVisible('hladinaProvizie','liw_filip__wiz_kalkulacia__cb_hladina_provizie')">
            <dynamic-combo
              dynamic
              :parentReloaded="reloaded"
              @valueChanged="forceProduktFormsDirty = true"
              :cisloPredmetu="pripad.cisloPredmetu"
              dataId="liw_filip__wiz_kalkulacia__cb_hladina_provizie"
              clearable
              ref="hladinaProvizie"
              :disabled="isCalculating"
            />
          </v-col>
          <v-col xl="4" lg="4" md="4" sm="12">
            <date-picker
              ref="datum_podpisu"
              placeholder="DD/MM/YYYY"
              dynamic
              :parentReloaded="reloaded"
              @valueChanged="onDatumPodpisuValueChanged"
              :cisloPredmetu="pripad.cisloPredmetu"
              dataId="liw_filip__wiz_kalkulacia__txt_datum_podpisu"
              :disabled="isCalculating"
              :min="formatDate(new Date())"
              @dataLoaded="(val) => setMinDatumDodania(val)"
              lastDayInMonth
            />
          </v-col>
          <v-col xl="4" lg="4" md="4" sm="12">
            <date-picker
              ref="datum_dodania"
              placeholder="DD/MM/YYYY"
              dynamic
              :parentReloaded="reloaded"
              @valueChanged="onDatumDodaniaValueChanged"
              :cisloPredmetu="pripad.cisloPredmetu"
              dataId="liw_filip__wiz_kalkulacia__txt_datum_dodania"
              :disabled="isCalculating"
              :min="formatDate(minDatumDodania)"
            />
          </v-col>
        </v-row>
        <v-row class="mobile-flex-direction-kalkulacia">
          <v-col xl="4" lg="4" md="4" sm="12">
            <button-group
              switchBtn
              small
              dynamic
              v-model="btnDphValue"
              staticLabel="Zobrazenie výpočtu"
              ref="btn_dph"
              @valueChanged="btnDphValueChanged"
              dataId="liw_filip__wiz_kalkulacia_produkt__btn_s_dph"
              :key="'liw_filip__wiz_kalkulacia_produkt__btn_s_dph'"
              :disabled="isCalculating"
              :cisloPredmetu="pripad.cisloPredmetu"
              :ignoreDirty="true"
            ></button-group>
          </v-col>
          <v-col v-show="isControlVisible('EIB_financovanie','liw_filip__wiz_kalkulacia__btn_eib_financovanie')"
            xl="4" lg="4" md="4" sm="12" style="align-self: center">
            <check-box
              ref="EIB_financovanie"
              label="EIB financovanie"
              dataId="liw_filip__wiz_kalkulacia__btn_eib_financovanie"
              :cisloPredmetu="pripad.cisloPredmetu"
              :style="!isMobile ? { marginTop: '20px' } : { marginTop: '0px !important' }"
              @valueChanged="forceProduktFormsDirty = true"
              :parentReloaded="reloaded"
              :disabled="isCalculating"
              hideDetails
            />
          </v-col>
          <v-col v-show="isControlVisible('datum_akontacie','liw_filip__wiz_kalkulacia__txt_datum_akontacie')"
            xl="4" lg="4" md="4" sm="12">
            <date-picker
              ref="datum_akontacie"
              placeholder="DD/MM/YYYY"
              dynamic
              :parentReloaded="reloaded"
              @valueChanged="forceProduktFormsDirty = true"
              :cisloPredmetu="pripad.cisloPredmetu"
              dataId="liw_filip__wiz_kalkulacia__txt_datum_akontacie"
              :disabled="isCalculating"
              @dataLoaded="() => datumAkontacieLoaded()"
            />
          </v-col>
        </v-row>
      </v-card>
      <v-card class="card" :class="isMobile ? 'mt-16px' : 'mt-30px'" v-show="visibleProvizie">
        <v-expansion-panels class="wizard-expansion-panels"  accordion flat v-model="showProvizie">
          <v-expansion-panel >
            <v-expansion-panel-header class="pa-0">
              <h2>
                Provízie
              </h2>
            </v-expansion-panel-header>
            <v-expansion-panel-content eager class="mt-12px">
              <v-row class="mobile-flex-direction-kalkulacia">
                <v-col md="6" cols="12" v-show="isControlVisible('btn_prov_dod','liw_filip__wiz_kalkulacia__btn_perc_suma_dod',true)">
                  <v-row>
                    <v-col>Dodávateľ</v-col>
                  </v-row>
                  <v-row>
                    <v-col xl="4" lg="4" md="4" sm="12" class="align-content-start">
                      <button-group
                        switchBtn
                        dynamic
                        v-model="btnProvDodValue"
                        ref="btn_prov_dod"
                        dataId="liw_filip__wiz_kalkulacia__btn_perc_suma_dod"
                        :key="'liw_filip__wiz_kalkulacia__btn_perc_suma_dod'"
                        :reloaded="reloaded"
                        :disabled="isCalculating"
                        :cisloPredmetu="pripad.cisloPredmetu"
                        @valueChanged="btnProvDodValueChanged"
                      ></button-group>
                    </v-col>
                    <v-col xl="8" lg="8" md="8" sm="12">
                      <numeric-text-box
                        v-show="btnProvDodValue == 0"
                        ref="prov_dod_perc"
                        key="liw_filip__wiz_kalkulacia__txt_prov_dod_perc"
                        data-id="liw_filip__wiz_kalkulacia__txt_prov_dod_perc"
                        :reloaded="reloaded"
                        :cisloPredmetu="pripad.cisloPredmetu"
                        :disabled="isCalculating"
                        suffix="%"
                        stopMouseDown
                        emitToParent
                        @valueChanged="akontaciaTenorValid"
                        @validationChanged="val => setProvizieError('prov_dod_perc', val)"
                      />
                      <numeric-text-box
                        v-show="btnProvDodValue == 1"
                        ref="prov_dod_sum"
                        key="liw_filip__wiz_kalkulacia__txt_prov_dod_suma"
                        data-id="liw_filip__wiz_kalkulacia__txt_prov_dod_suma"
                        :reloaded="reloaded"
                        :cisloPredmetu="pripad.cisloPredmetu"
                        :disabled="isCalculating"
                        suffix="€"
                        stopMouseDown
                        emitToParent
                        @valueChanged="akontaciaTenorValid"
                        @validationChanged="val => setProvizieError('prov_dod_sum', val)"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col md="6" cols="12" v-show="isControlVisible('btn_prov_dod_p','liw_filip__wiz_kalkulacia__btn_perc_suma_dod_p',true)">
                  <v-row>
                    <v-col>
                      Predajca dodávateľa
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col xl="4" lg="4" md="4" sm="12" class="align-content-start">
                      <button-group
                        switchBtn
                        dynamic
                        v-model="btnProvDodPredajcaValue"
                        ref="btn_prov_dod_p"
                        dataId="liw_filip__wiz_kalkulacia__btn_perc_suma_dod_p"
                        :key="'liw_filip__wiz_kalkulacia__btn_perc_suma_dod_p'"
                        :reloaded="reloaded"
                        :disabled="isCalculating"
                        :cisloPredmetu="pripad.cisloPredmetu"
                        @valueChanged="btnProvDodPredajcaValueChanged"
                      ></button-group>
                    </v-col>
                    <v-col xl="8" lg="8" md="8" sm="12">
                      <numeric-text-box
                        v-show="btnProvDodPredajcaValue == 0"
                        ref="prov_dod_p_perc"
                        key="liw_filip__wiz_kalkulacia__txt_prov_dod_p_perc"
                        data-id="liw_filip__wiz_kalkulacia__txt_prov_dod_p_perc"
                        :reloaded="reloaded"
                        :cisloPredmetu="pripad.cisloPredmetu"
                        :disabled="isCalculating"
                        suffix="%"
                        stopMouseDown
                        emitToParent
                        @valueChanged="akontaciaTenorValid"
                        @validationChanged="val => setProvizieError('prov_dod_p_perc', val)"
                      />
                      <numeric-text-box
                        v-show="btnProvDodPredajcaValue == 1"
                        ref="prov_dod_p_sum"
                        key="liw_filip__wiz_kalkulacia__txt_prov_dod_p_suma"
                        data-id="liw_filip__wiz_kalkulacia__txt_prov_dod_p_suma"
                        :reloaded="reloaded"
                        :cisloPredmetu="pripad.cisloPredmetu"
                        :disabled="isCalculating"
                        suffix="€"
                        stopMouseDown
                        emitToParent
                        @valueChanged="akontaciaTenorValid"
                        @validationChanged="val => setProvizieError('prov_dod_p_sum', val)"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="mobile-flex-direction-kalkulacia">
                <v-col md="6" cols="12" v-show="isControlVisible('btn_prov_spros','liw_filip__wiz_kalkulacia__btn_perc_suma_spros',true)">
                  <v-row>
                    <v-col>
                      Sprostredkovateľ
                    </v-col>
                  </v-row>
                  <v-row class="mobile-flex-direction-kalkulacia">
                    <v-col xl="4" lg="4" md="4" sm="12" class="align-content-start">
                      <button-group
                        switchBtn
                        dynamic
                        v-model="btnProvSprosValue"
                        ref="btn_prov_spros"
                        dataId="liw_filip__wiz_kalkulacia__btn_perc_suma_spros"
                        :key="'liw_filip__wiz_kalkulacia__btn_perc_suma_spros'"
                        :reloaded="reloaded"
                        :disabled="isCalculating"
                        :cisloPredmetu="pripad.cisloPredmetu"
                        @valueChanged="btnProvSprosValueChanged"
                        ></button-group>
                      </v-col>
                      <v-col xl="8" lg="8" md="8" sm="12">
                        <numeric-text-box
                        v-show="btnProvSprosValue == 0"
                        ref="prov_spros_perc"
                        key="liw_filip__wiz_kalkulacia__txt_prov_spros_perc"
                        data-id="liw_filip__wiz_kalkulacia__txt_prov_spros_perc"
                        :reloaded="reloaded"
                        :cisloPredmetu="pripad.cisloPredmetu"
                        :disabled="isCalculating"
                        suffix="%"
                        stopMouseDown
                        emitToParent
                        @valueChanged="akontaciaTenorValid"
                        @validationChanged="val => setProvizieError('prov_spros_perc', val)"
                      />
                      <numeric-text-box
                        v-show="btnProvSprosValue == 1"
                        ref="prov_spros_sum"
                        key="liw_filip__wiz_kalkulacia__txt_prov_spros_suma"
                        data-id="liw_filip__wiz_kalkulacia__txt_prov_spros_suma"
                        :reloaded="reloaded"
                        :cisloPredmetu="pripad.cisloPredmetu"
                        :disabled="isCalculating"
                        suffix="€"
                        stopMouseDown
                        emitToParent
                        @valueChanged="akontaciaTenorValid"
                        @validationChanged="val => setProvizieError('prov_spros_sum', val)"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col md="6" cols="12" v-show="isControlVisible('btn_prov_spros_p','liw_filip__wiz_kalkulacia__btn_perc_suma_spros_p',true)">
                  <v-row>
                    <v-col>
                      Predajca sprostredkovateľa
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col xl="4" lg="4" md="4" sm="12" class="align-content-start">
                      <button-group
                        switchBtn
                        dynamic
                        v-model="btnProvSprosPredajcaValue"
                        ref="btn_prov_spros_p"
                        dataId="liw_filip__wiz_kalkulacia__btn_perc_suma_spros_p"
                        :key="'liw_filip__wiz_kalkulacia__btn_perc_suma_spros_p'"
                        :reloaded="reloaded"
                        :disabled="isCalculating"
                        :cisloPredmetu="pripad.cisloPredmetu"
                        @valueChanged="btnProvSprosPredajcaValueChanged"
                      ></button-group>
                    </v-col>
                    <v-col xl="8" lg="8" md="8" sm="12">
                      <numeric-text-box
                        v-show="btnProvSprosPredajcaValue == 0"
                        ref="prov_spros_p_perc"
                        key="liw_filip__wiz_kalkulacia__txt_prov_spros_p_perc"
                        data-id="liw_filip__wiz_kalkulacia__txt_prov_spros_p_perc"
                        :reloaded="reloaded"
                        :cisloPredmetu="pripad.cisloPredmetu"
                        :disabled="isCalculating"
                        suffix="%"
                        stopMouseDown
                        emitToParent
                        @validationChanged="val => setProvizieError('prov_spros_p_perc', val)"
                      />
                      <numeric-text-box
                        v-show="btnProvSprosPredajcaValue == 1"
                        ref="prov_spros_p_sum"
                        key="liw_filip__wiz_kalkulacia__txt_prov_spros_p_suma"
                        data-id="liw_filip__wiz_kalkulacia__txt_prov_spros_p_suma"
                        :reloaded="reloaded"
                        :cisloPredmetu="pripad.cisloPredmetu"
                        :disabled="isCalculating"
                        suffix="€"
                        stopMouseDown
                        emitToParent
                        @validationChanged="val => setProvizieError('prov_spros_p_sum', val)"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="mobile-flex-direction-kalkulacia" v-if="provizieError">
                <v-col class="negative500 d-flex" style="gap: 6px" >
                  <v-icon color="error" size="16">mdi-alert-circle</v-icon>
                  Bola prekročená maximálna výška zazmluvnenej provízie.
                </v-col>
              </v-row>

              
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
      <div v-for="(item, index) in produkty" :key="index">
        <produkt-form
          :ref="'produktForm_' + index"
          @produktFormDirty="produktFormDirty"
          @onVariantSelected="onVariantSelected"
          @loadingOverlayChanged="handleProduktLoadingOverlayChanged"
          :forceFormDirty="forceProduktFormsDirty"
          :reloaded="reloaded"
          :cisloPlz="item.cislo_plz"
          :idProduktu="item.id"
          :jeOlfs="item.jeOlfs"
          :cisloPredmetu="pripad.cisloPredmetu"
          :nazovProduktu="item.nazov"
          :dph="btnDphValue === 1 ? false : true"
          :key="'produktForm_' + index + ' ' + produktFormKey"
          :isCalculating="isCalculating"
          @initLoaded="produktFormLoaded"
          v-model="produktyValid[index]"
          @produktValid="(val) =>setProduktValid(index,val)"
          @updateCisloPlz="(val) => item.cislo_plz = val"
          :rules="[produktRule]"
          @loadedVarianty="loadedVarianty"
        />
      </div>
    </v-form>
    <message-box
      v-model="warningMessage.open"
      :title="warningMessage.title"
      :text="warningMessage.text"
      :action="warningMessage.action"
      persistent
      :yesNo="warningMessage.yesNo"
      :hideCancel="warningMessage.hideCancel"
    />
  </v-container>
</template>
<script>
import CheckBox from '../basic/CheckBox.vue';
import DynamicCombo from '../basic/DynamicCombo.vue';
import AkontaciaButtonGroup from '../basic/AkontaciaButtonGroup.vue';
import ButtonGroup from '../basic/ButtonGroup.vue';
import TextBox from '../basic/TextBox.vue';
import NumericTextBox from '../basic/NumericTextBox.vue';
import MessageBox from '../basic/MessageBox.vue';
import DatePicker from '../basic/DatePicker.vue';
import { wizardMixin } from '../../mixins/wizardMixin.js';
import { globalMixin } from '../../mixins/globalMixin.js';
import { controlMixin } from '../../mixins/controlMixin.js';
import ProduktForm from '../produkt/ProduktForm.vue';
import protectedAxios from '../../auth/axios';
import { mapState, mapMutations, mapGetters } from 'vuex';
import { eventBus } from '../../main.js';

export default {
  mixins: [wizardMixin, globalMixin,controlMixin],
  components: {
    TextBox,
    DynamicCombo,
    CheckBox,
    AkontaciaButtonGroup,
    ButtonGroup,
    DatePicker,
    NumericTextBox,
    MessageBox,
    ProduktForm,
  },
  data() {
    return {
      defaultMessage: {
        text: '',
        isError: false,
      },
      warningMessage: {
        open: false,
        title: 'Prajete si spustiť kalkuláciu bez výberu Hladiny provízie?',
        text: '',
        action: this.spustiKalkulaciu,
        yesNo: true,
        hideCancel: false,
      },
      kalkulaciaError: false,
      forceProduktFormsDirty: false,
      isAnyProduktFormDirty: false,
      produkty: [],
      isCalculating: false,
      footerCalculationProgress: false,
      produktFormKey: 0,
      produktErrorIgnoredAfterInputChange: false,
      btnDphValue: null,
      formValid: true,
      tenor: null,
      akontacia: null,
      akontaciaMandatory: false,
      minDatumDodania: null,
      produktyValid: [],
      needCalculating: false,
      btnProvDodValue: 0,
      btnProvDodPredajcaValue: 0,
      btnProvSprosValue: 0,
      btnProvSprosPredajcaValue: 0,
      provizieErrors: {
        prov_dod_perc: null,
        prov_dod_sum: null,
        prov_dod_p_perc: null,
        prov_dod_p_sum: null,
        prov_spros_perc: null,
        prov_spros_sum: null,
        prov_spros_p_perc: null,
        prov_spros_p_sum: null,
      },
      produktLoadingOverlayCounter: 0,
      produktLoadingOverlayText: '',
      showProvizie: undefined
    };
  },
  computed: {
    ...mapState(['pripad']),
    produktRule(v){
      return v => v == "" || v
    },
    visibleProvizie(){
      let dod = this.isControlVisible('btn_prov_dod','liw_filip__wiz_kalkulacia__btn_perc_suma_dod')
      let dod_predajca = this.isControlVisible('btn_prov_dod_p','liw_filip__wiz_kalkulacia__btn_perc_suma_dod_p')
      let spros = this.isControlVisible('btn_prov_spros','liw_filip__wiz_kalkulacia__btn_perc_suma_spros')
      let spros_predajca = this.isControlVisible('btn_prov_spros_p','liw_filip__wiz_kalkulacia__btn_perc_suma_spros_p')
      return dod || dod_predajca || spros || spros_predajca;
    },
    provizieError(){
      return Object.values(this.provizieErrors).find(Boolean) ?? null;
    },
    produktValidationError(){
      return this.produktyValid.find(c => c != "") ?? "";
    }
  },
  watch: {
    formValid(val) {
      if (val){
        if(this.spustitKalkulaciuEnabled() && !this.hasValidationErrorExcept('spustenieKalkulacie')){
         this.setValid(true, 'spustenieKalkulacie', '', false);
        }
      }
    },
    provizieError(val){
      if (val) {
        this.setValid(
          false,
          'provizieValid',
          'Bola prekročená maximálna výška zazmluvnenej provízie.',
          false,
          true
        );
        this.setKalkulaciaCustomButton(true, false, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
        this.showProvizie = 0;
      } else {
        this.setKalkulaciaCustomButton(true, true, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
        if (!this.hasValidationErrorExcept('provizieValid')) {
          this.setValid(true, 'provizieValid', '', false);
        }
      }
    },
    async currentControl(val) {
      //zobrazil sa formular kalkulacia val = PripadyWizardKalkulacia
      let changedCache = await this.checkCacheChanged();
      if (
        val === this.controlName
      ){ 
        if(this.produktValidationError) {
          this.produktErrorIgnoredAfterInputChange = false;
          this.setValid(false, 'produktValid', this.produktValidationError, false, true);
          this.setKalkulaciaCustomButton(true, false, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
        } else if(this.isAnyProduktFormDirty || this.pripad.handleExit || this.pripad.jeRozpracovany || changedCache) {
          this.needCalculating= true;
          this.$nextTick(()=>{
            this.waitLoadingForCheck()
          });
        }else{
          this.resetAllValidation();
        }
      }
    },
    produktyValid:{
      handler(val) {
        let produktError = this.produktyValid
          .filter(c => c != "");
        if(produktError.length > 0){
          this.needCalculating = true;
          this.setValid(false, 'produktValid', produktError[0], false, true);
          this.setKalkulaciaCustomButton(true, false, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
          // this.setKalkulaciaCustomButton(true, false, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
        }else{
          if (!this.hasValidationErrorExcept('produktValid')) {
              this.setValid(true, 'produktValid', '', false);
            }
          if(this.currentControl === this.controlName && (this.needCalculating || this.isAnyProduktFormDirty)) {
            this.setKalkulaciaCustomButton(true, this.spustitKalkulaciuEnabled(), 'Spustiť kalkuláciu', this.checkHladinyProvizie);
          }
        }
      },
      deep: true,
      
    }
  },
  methods: {
    ...mapMutations(['setHandleExit', 'setJeRozpracovany', 'openDialog']),
    hasValidationErrorExcept(...excludedProperties) {
      return Object.entries(this.validationObject).some(
        ([property, value]) => !excludedProperties.includes(property) && value === false
      );
    },
    setKalkulaciaCustomButton(visible, enabled, text, onClick) {
      if (this.currentControl === this.controlName) {
        this.$emit('setCustomButton', {
          visible: visible,
          enabled: enabled,
          text: text,
          onClick: onClick,
        });
      }
    },
    clearKalkulaciaCustomButton() {
      if (this.currentControl === this.controlName) {
        this.clearCustomButton();
      }
    },
    hasBlockingProduktValidationError() {
      return !!this.produktValidationError && !this.produktErrorIgnoredAfterInputChange;
    },
    ignoreProduktErrorAfterInputChange() {
      if (this.currentControl === this.controlName && this.produktValidationError) {
        this.produktErrorIgnoredAfterInputChange = true;
      }
    },
    emitFinalValid(val) {
      if (this.currentControl === this.controlName) {
        const message =
          this.footerCalculationProgress && !this.wizardMessage.text
            ? { text: 'Na pozadí prebieha kalkulácia', isError: false }
            : this.wizardMessage;
        this.$emit('validationChanged', {
          message,
          valid: val,
          blocked: this.wizardBlocked,
          controlName: this.controlName,
          showProgress: this.wizardMessageProgress || this.footerCalculationProgress,
        });
      }
    },
    setFooterCalculationProgress(value) {
      this.footerCalculationProgress = value;
      this.emitFinalValid(this.finalValidationResult);
    },
    handleProduktLoadingOverlayChanged({ open, text }) {
      if (open) {
        this.produktLoadingOverlayCounter += 1;
        this.produktLoadingOverlayText = text;
      } else {
        this.produktLoadingOverlayCounter = Math.max(0, this.produktLoadingOverlayCounter - 1);
        if (this.produktLoadingOverlayCounter === 0) {
          this.produktLoadingOverlayText = '';
        }
      }

      this.$emit('loadingOverlayChanged', {
        loading: this.produktLoadingOverlayCounter > 0,
        text: this.produktLoadingOverlayText,
      });
    },
    spustitKalkulaciuEnabled() {
        return Boolean(
          (this.$refs.cbAkontacia.l_value?.length ||
            this.$refs.txtAkontacia.getValue() ||
            this.$refs.txtAkontacia.getValue() === 0) &&
            this.$refs.tenor.l_value?.length > 0 &&
            !this.isCalculating && this.formValid &&
            !this.hasBlockingProduktValidationError() &&
            (this.validationObject?.checkAkontacia ?? true)
        );      
    },
    akontaciaTenorValid() {
      if (!this.spustitKalkulaciuEnabled()) {
        let changeText = true;
        if(!this.validationObjectResult){
          if(Object.entries(this.validationObject).find((element) => element[0] != 'spustenieKalkulacie' && element[1] == false))
            changeText = false;
        }
        if(changeText){
          this.setValid(
            false,
            'spustenieKalkulacie',
            'Pre spustenie kalkulácie je potrebné zvoliť si Akontáciu a Tenor',
            false,
            false
          );
        }
        this.needCalculating= true;
        if (this.currentControl === this.controlName) {
          this.setKalkulaciaCustomButton(true, false, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
        }
        return false;
      }
      if (this.currentControl === this.controlName) {
        this.setKalkulaciaCustomButton(true, true, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
      }
      if (!this.hasValidationErrorExcept('spustenieKalkulacie')) {
        this.setValid(true, 'spustenieKalkulacie', '', false);
      }
      return true;
    },
    akontaciaTxtFocus() {
      this.akontaciaMandatory = false;
      this.$refs.cbAkontacia.onChange(null);
      this.akontaciaTenorChanged();
    },
    async akontaciaTxtChanged(){
      const akontaciaMsg = await protectedAxios
          .get(
            `/kalk/check-akontacia`
          )
          .then(res => res.data)
          .catch(e => (
            console.error(e)
          ));
      if(akontaciaMsg){
        this.setValid(false, 'checkAkontacia', akontaciaMsg, false, true,true);
        console.warn("Check akontacia error: " + akontaciaMsg);
        this.setKalkulaciaCustomButton(true, false, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
        return
      }else{
        if (!this.hasValidationErrorExcept('checkAkontacia')) {
          this.setValid(true, 'checkAkontacia', '', false, false);
        }
      }

      this.akontaciaTenorChanged()
    },
    akontaciaTenorChanged() {
      this.ignoreProduktErrorAfterInputChange();
      if (this.$refs.cbAkontacia.l_value?.length) {
        if (!this.hasValidationErrorExcept('checkAkontacia')) {
          this.setValid(true, 'checkAkontacia', '', false, false);
        }
        this.$refs.txtAkontacia.setValue(null);
        this.akontaciaMandatory = true;
      }
      if(this.pripad.jeOlfs){
        this.$refs.rocny_najazd.loadData();
      }
      if (this.forceProduktFormsDirty) {
        this.produktFormDirty(true); //volam aj ked je uz dirty lebo chcem aby sa menil custom button enabled
      } else {
        this.forceProduktFormsDirty = true;
      }
      this.akontaciaTenorValid();

      this.btnProvDodValueChanged();
      this.btnProvDodPredajcaValueChanged();
      this.btnProvSprosValueChanged();
      this.btnProvSprosPredajcaValueChanged();

    },
    onRocnyNajazdChanged(){
      this.$refs.tenor.l_data = [];
      this.$refs.tenor.loadData();
      this.ignoreProduktErrorAfterInputChange();
      this.akontaciaTenorValid();
    },
    produktFormDirty(val) {
      this.isAnyProduktFormDirty = val;
      if (val && this.currentControl === this.controlName && !this.isCalculating) {
        this.ignoreProduktErrorAfterInputChange();
        this.$nextTick(()=> {
          this.akontaciaTenorValid();
          this.needCalculating= true;       
        })
      } else if (this.isCalculating) {
        this.needCalculating= false;
        this.clearKalkulaciaCustomButton();
      }
    },
    async loadData() {
      await this.$refs.btn_dph.loadData();

      await this.$refs.btn_prov_dod.loadData().then(()=> this.btnProvDodValueChanged());
      await this.$refs.btn_prov_dod_p.loadData().then(() => this.btnProvDodPredajcaValueChanged());
      await this.$refs.btn_prov_spros.loadData().then(()=> this.btnProvSprosValueChanged());
      await this.$refs.btn_prov_spros_p.loadData().then(() => this.btnProvSprosPredajcaValueChanged());

      return protectedAxios
        .get(
          `/pripady/${this.pripad.newId}/predmety/${
            this.pripad.cisloPredmetu
          }/produkty`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {
          this.produkty = res.data;
          this.produktFormKey++;
        })
        .catch(_ => {
          this.setValid(false, 'spustenieKalkulacie', 'Chyba pri načítaní dát', false, true);
        });
    },
    reload() {
      this.loadData();
    },
    getProduktFormComponents() {
      return Object.keys(this.$refs)
        .filter(key => key.startsWith('produktForm_'))
        .map(key => Array.isArray(this.$refs[key]) ? this.$refs[key][0] : this.$refs[key])
        .filter(Boolean);
    },
    waitForProduktFormsReloaded() {
      return new Promise(resolve => {
        const checkReloaded = () => {
          const produktForms = this.getProduktFormComponents();
          if (produktForms.length === 0) {
            resolve();
            return;
          }
          if (produktForms.every(form => form.produktFormReloaded === true)) {
            resolve();
            return;
          }
          setTimeout(checkReloaded, 50);
        };

        this.$nextTick(() => {
          checkReloaded();
        });
      });
    },
    getAkontaciaForVariantsCheck() {
      const value = this.$refs.cbAkontacia.l_value;
      if (!value) {
        return this.$refs.txtAkontacia.getValue();
      }

      if (Array.isArray(value)) {
        const min = Math.min(...value.map(item => +item.split(',')[0]));
        const max = Math.max(...value.map(item => +item.split(',')[1]));
        return [min, max];
      }

      return value.split(',').map(x => +x);
    },
    checkHladinyProvizie() {
      if (this.hasBlockingProduktValidationError()) {
        this.setValid(false, 'produktValid', this.produktValidationError, false, true);
        this.setKalkulaciaCustomButton(true, false, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
        return;
      }
      let isValidForm = this.$refs.form.validate();
      if (!isValidForm) {
        this.setValid(
          false,
          'spustenieKalkulacie',
          'Pre pokračovanie prosím vyplňte všetky povinné polia!',
          false,
          true
        );
        this.needCalculating= true;
        this.setKalkulaciaCustomButton(true, false, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
        return;
      }
      if (
        this.$refs.hladinaProvizie.currentValue ||
        this.$refs.hladinaProvizie.l_visible === false ||
        this.$refs.hladinaProvizie.l_isEnabled === false
      ) {
        this.spustiKalkulaciu();
      } else if (
        this.$refs.hladinaProvizie.l_visible === true &&
        this.$refs.hladinaProvizie.l_isEnabled === true
      ) {
        this.warningMessage.open = true;
        this.warningMessage.title = 'Prajete si spustiť kalkuláciu bez výberu Hladiny provízie?';
        this.warningMessage.text = '';
        this.warningMessage.action = this.spustiKalkulaciu;
        this.warningMessage.yesNo = true;
        this.warningMessage.hideCancel = false;
      }
    },
    async spustiKalkulaciu() {
      if (this.hasBlockingProduktValidationError()) {
        this.setValid(false, 'produktValid', this.produktValidationError, false, true);
        this.setKalkulaciaCustomButton(true, false, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
        return;
      }
      if (!this.$refs.form.validate()) return;
      if (!this.akontaciaTenorValid()) return;
      this.produktErrorIgnoredAfterInputChange = false;
      //if (this.pripad.handleExit) this.forceProduktFormsDirty = true; //TODO: nejde lebo treba delay
      this.setKalkulaciaCustomButton(true, false, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
      await protectedAxios
        .get(
          `/pripady/${this.pripad.newId}/predmety/${
            this.pripad.cisloPredmetu
          }/check-changed-dodavatel`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {
          var idDodavatelZmena = res.data
          
      
      this.kalkulaciaError = false;    
      this.isCalculating = true;
      let promisesKalk = [];
      let promisesPoKalk = [];

      for (let property in this.$refs) {
        if (this.$refs[property][0]) {
          if (typeof this.$refs[property][0].spustiKalkulaciu === 'function') {
            if (this.pripad.handleExit || this.pripad.jeRozpracovany || this.needCalculating)
              this.$refs[property][0].setDirty(true);
              promisesKalk.push(() => this.$refs[property][0].spustiKalkulaciu(idDodavatelZmena));
              if (typeof this.$refs[property][0].nacitaniePoKalkulacii === 'function') {
                promisesPoKalk.push(() => this.$refs[property][0].nacitaniePoKalkulacii());
              }
          }
        }
      }
      this.setValid(
        false,
        'spustenieKalkulacie',
        'Na pozadí prebieha kalkulácia',
        true,
        false,
        true
      );
      this.setFooterCalculationProgress(true);

      let cislaPlz = [];
      Promise.all(
        promisesKalk.map(p =>
          p().then(res =>{
              cislaPlz.push(res.data.cisloPlz);
            return res;
          }).catch(e => {
            return Promise.reject(e);
          })
        )
      )
        .then(async results => {
          // nacitat systemovy parameter
          return await this.schvalovaniePoPrekalkulovani(cislaPlz).then(async _ =>{
            // vytvorit dalsi promise array na spustenie funkcie "poKalkulacii" -> pridat do produktForm -> clearnutie a nacitanie variantov
            return Promise.all(
              promisesPoKalk.map(p =>
                p().catch(e => {
                  return Promise.reject(e);
                })
              )
            ).then(async _res =>{
              if (!this.kalkulaciaError) {
                return await protectedAxios
                  .post(
                    `controls/setCacheChanged`,
                    {
                      newId: this.pripad.newId,
                      cache: false
                    },
                    {
                      headers: {
                        'Content-Type': 'application/json',
                      },
                    }
                  )
                  .then(async res => {
                    return await this.saveObcPripad().then(async () => {
                      this.needCalculating= false;

                      this.clearKalkulaciaCustomButton();
                      this.clearDirty();
                      this.forceProduktFormsDirty = false;
                      this.isAnyProduktFormDirty = false;
                      this.resetAllValidation();
                      this.isCalculating = false;
                      await this.loadData();
                      await this.waitForProduktFormsReloaded();
                      await this.checkVariants();
                      if (this.produktValidationError) {
                        this.needCalculating = true;
                        this.setValid(false, 'produktValid', this.produktValidationError, false, true);
                        this.setKalkulaciaCustomButton(true, false, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
                      }
                      this.setFooterCalculationProgress(false);
                    });
                  });
              } else {
                this.clearKalkulaciaCustomButton();
                this.clearDirty();
                this.forceProduktFormsDirty = false;
                this.isAnyProduktFormDirty = false;
                this.isCalculating = false;
                this.needCalculating= true;
                this.setFooterCalculationProgress(false);
                this.setKalkulaciaCustomButton(
                  true,
                  this.spustitKalkulaciuEnabled(),
                  'Spustiť kalkuláciu',
                  this.checkHladinyProvizie
                );
              }
              this.kalkulaciaError = false;
            })
          })
        })
        .catch(e => {
          this.handleException(e);
        });
        })
        .catch(_ => {
          this.kalkulaciaError = true;
          this.isCalculating = false;
          this.setFooterCalculationProgress(false);
          this.setValid(false, 'spustenieKalkulacie', 'Chyba pri načítaní dát', false, true);
          this.setKalkulaciaCustomButton(true, true, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
        });
    },
    handleException(e) {
      this.kalkulaciaError = true;
      let error_text = 'Chyba pri kalkulácii'; //TODO: dat toto globalne na komponentu
      console.error(e);

      if (typeof e === 'string' && e.length > 0) {
        error_text = e;
      } else if (e.response?.data?.error_text) {
        error_text = e.response.data.error_text;
      }
      if(e.response?.data?.error_code == 663){
        this.$emit('setNotAliveComponent');
      }
      this.isCalculating = false;
      this.setFooterCalculationProgress(false);
      this.setValid(false, 'spustenieKalkulacie', error_text, false, true,false);
      this.setKalkulaciaCustomButton(true, true, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
    },
    saveObcPripad() {
      //ak som uspesne prisiel az sem, tak rozpracovany je false
      this.setJeRozpracovany(false);
      return protectedAxios
        .post(
          `pripady/save`,
          {
            newId: this.pripad.newId,
            cisloPredmetu: this.pripad.cisloPredmetu,
            idZastupcu: this.pripad.idZastupcu,
            jeRozpracovany: this.pripad.jeRozpracovany,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {
          this.setHandleExit(false);
          return res;
        })
        .catch(_ => {
          this.isCalculating = false;
          this.setFooterCalculationProgress(false);
          this.setValid(
            false,
            'spustenieKalkulacie',
            'Chyba pri ukladaní obchodného prípadu',
            false,
            true
          );
          this.needCalculating= true;

          this.setKalkulaciaCustomButton(
            true,
            this.spustitKalkulaciuEnabled(),
            'Spustiť kalkuláciu',
            this.checkHladinyProvizie
          );
        });
    },
    btnDphValueChanged() {
      this.loadData();
    },
    btnProvDodValueChanged() {
      this.$refs.prov_dod_sum.loadData();
      this.$refs.prov_dod_perc.loadData();
    },
    btnProvDodPredajcaValueChanged() {
      this.$refs.prov_dod_p_sum.loadData();
      this.$refs.prov_dod_p_perc.loadData();
    },
    btnProvSprosValueChanged() {
      this.$refs.prov_spros_sum.loadData();
      this.$refs.prov_spros_perc.loadData();
    },
    btnProvSprosPredajcaValueChanged() {
      this.$refs.prov_spros_p_sum.loadData();
      this.$refs.prov_spros_p_perc.loadData();
    },
    async checkVariants() {
      //overi, ci vsetky produkty maju nejake varianty
      let success = true;
      let varianty = [];
      for (let property in this.$refs) {
        if (this.$refs[property][0]) {
          if (typeof this.$refs[property][0].hasVariants === 'function') {
            if (!this.$refs[property][0].hasVariants()) {
              await protectedAxios
                .post(
                  `kalk/varianty/empty/reason`,
                  {
                    IdProduktu: this.$refs[property][0].idProduktu,
                    Akontacia: this.getAkontaciaForVariantsCheck(),
                    Tenor: this.$refs.tenor.l_value.map(x => +x),
                  },
                  {
                    headers: {
                      'Content-Type': 'application/json',
                    },
                  }
                )
                .then(res => {
                  varianty.push({
                    title: this.$refs[property][0].getNazovProduktu(),
                    reasons: res.data,
                  });
                  if (res.data.length > 0) success = false;
                });
            }
          }
        }
      }
      if (!success) {
        let text = '';
        let variantyAkontacia = varianty.filter(v => v.reasons.includes('akontacia'));
        if (variantyAkontacia.length > 0) {
          text += `<p>
              Vami zvolenú akontáciu nie je možné použiť pri kalkulovaní vybratého
              produktu/produktov:
            </p>`;
          for (let i = 0; i < variantyAkontacia.length; i++) {
            text += `<p>
                ${variantyAkontacia[i].title}
              </p>`;
          }
          text += `<p>
              Prosím vyberte inú akontáciu alebo odznačte vybratý produkt/produkty v záložke
              Produkt.
            </p>`;
        }
        let variantyTenor = varianty.filter(v => v.reasons.includes('dlzka_leasingu'));
        if (variantyTenor.length > 0) {
          text += `<p>
              Vami zvolenú dĺžku splácania nie je možné použiť pri kalkulovaní vybratého
              produktu/produktov:
            </p>`;
          for (let i = 0; i < variantyTenor.length; i++) {
            text += `<p>
                ${variantyTenor[i].title}
              </p>`;
          }
          text += `<p>
              Prosím vyberte inú dĺžku splácania alebo odznačte zvolený produkt/produkty v záložke
              Produkt.
            </p>`;
        }
        let dialog = {
          persistent: true,
          header: `<span class="gs100 f16">Upozornenie</span>`,
          text: `<span class="f16 white100"> ${text} </span>`,
          closeIcon: {
            value: true,
          },
          closeBtn: {
            value: true,
            primaryStyle: true,
            text: 'OK',
          },
        };

        this.openDialog(dialog);
      }
    },
    onVariantSelected() {
      this.checkVariantsSelected();
    },
    checkVariantsSelected() {
      for (let property in this.$refs) {
        if (this.$refs[property][0]) {
          if (typeof this.$refs[property][0].getSelectedVariants === 'function') {
            if (this.$refs[property][0].getSelectedVariants().length > 0) {
              if (!this.hasValidationErrorExcept('variantsSelected')) {
                this.setValid(true, 'variantsSelected', '', false, false);
              }
              return true;
            }
          }
        }
      }
      this.setValid(
        false,
        'variantsSelected',
        'Vyberte si, prosím, aspoň jednu z možností financovania.',
        false,
        false
      );
      return false;
    },
    async beforeStep() {
      if (this.hasBlockingProduktValidationError()) {
        this.setValid(false, 'produktValid', this.produktValidationError, false, true);
        this.setKalkulaciaCustomButton(true, false, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
        return Promise.resolve(false);
      }
      if (!this.spustitKalkulaciuEnabled()) {
        this.setValid(
          false,
          'spustenieKalkulacie',
          'Pre spustenie kalkulácie je potrebné zvoliť si Akontáciu a Tenor',
          false,
          false
        );
        this.needCalculating= true;
        this.setKalkulaciaCustomButton(true, false, 'Spustiť kalkuláciu', this.checkHladinyProvizie);
        return Promise.resolve(false);
      }

      const akontaciaMsg = await protectedAxios
          .get(
            `/kalk/check-akontacia`
          )
          .then(res => res.data)
          .catch(e => (
            console.error(e)
          )); 
      if(akontaciaMsg){
        this.setValid(false, 'checkAkontacia', akontaciaMsg, false, true);
        return Promise.resolve(false);
      }
      
      if(this.needCalculating){
        return Promise.resolve(false)
      }

      if (!this.checkVariantsSelected()) {
        return Promise.resolve(false);
      }

      if (this.pripad.handleExit) {
        this.setValid(
          false,
          'ukladaniePripadu',
          'Na pozadí prebieha ukladanie zmien, prosím čakajte.',
          true
        );
        return this.saveObcPripad().then(() => {
          if (!this.hasValidationErrorExcept('ukladaniePripadu')) {
            this.setValid(true, 'ukladaniePripadu', '', false);
          }
          this.resetCache();
          this.setHandleExit(false);
          return true;
        });
      } else {
        return this.resetCache();
      }
    },
    produktFormLoaded() {
      this.$refs.datum_podpisu.loadedAll();
    },
    onDatumPodpisuValueChanged(val) {
      this.forceProduktFormsDirty = true;
      this.setMinDatumDodania(val);
      this.$refs.datum_dodania.loadData().then(() =>{
        this.$refs.datum_akontacie.loadData();
      });
    },
    setMinDatumDodania(val){
      if (val.length === 8) {
        val = `${val.substring(0, 4)}-${val.substring(4, 6)}-${val.substring(6, 8)}`;
      }

      this.minDatumDodania = new Date(val);
    },
    onDatumDodaniaValueChanged(){
      this.forceProduktFormsDirty = true;
      this.$refs.datum_akontacie.loadData();
    },
    formatDate(date) {
      if (date != null) {
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        if (month.toString().length < 2) month = '0' + month;
        if (day.toString().length < 2) day = '0' + day;
        return year + '-' + month + '-' + day;
      } else {
        return null;
      }
    },
    setProduktValid(index,val){
      if (val) {
        this.produktErrorIgnoredAfterInputChange = false;
      }
      this.$set(this.produktyValid, index, val)
    },
    resetAllValidation(){
      this.produktErrorIgnoredAfterInputChange = false;
      this.setValid(true, 'spustenieKalkulacie', '', false);
      this.setValid(true, 'checkAkontacia', '', false);
      this.setValid(true, 'produktValid', '', false);
      this.setValid(true, 'variantsSelected', '', false); 
      this.setValid(true, 'provizieValid', '', false); 
    },
    waitLoadingForCheck(){
      if(!this.somethingIsLoading && !this.$refs.cbAkontacia.isLoading && !this.$refs.txtAkontacia.isLoading && !this.$refs.tenor.isLoading){
        this.akontaciaTenorValid()
      }else{
        setTimeout(() =>{
          this.waitLoadingForCheck()
        },50)
      }
    },
    async loadedVarianty(){
      if (this.currentControl === this.controlName){ 
        if(this.needCalculating) {
          this.waitLoadingForCheck();
        }
      }
    },
    datumAkontacieLoaded(){
      eventBus.$emit('reloadSadzba');
    },
    setProvizieError(key, value) {
      this.$set(this.provizieErrors, key, value);
    },
  },
  created() {
    this.l_cisloPredmetu = this.pripad.cisloPredmetu;
  },
};
</script>
